import { useAppScope } from '@/core/AppScopeContext';
import type { AppPermission } from '@/core/types/permissions';

export const useHasPermission = (permission: AppPermission) => {
  const { hasPermission } = useAppScope();
  return hasPermission(permission);
};
